import t from '~/scopes/campaign/data/metals/aluminium.translations'
import SECTIONS from '~/scopes/campaign/data/metals/sections.translations'

export default {
  name: t.name,
  smartphone: {
    label: t.smartphoneLabel,
  },
  whatItDoes: {
    text: t.whatItDoesText,
    sourceRefs: ['gomez2023'],
  },
  extraction: [
    {
      text: t.extractionText1,
      sourceRefs: ['pblSocial2025'],
    },
  ],
  quickFact: {
    text: t.quickFactText,
    sourceRefs: ['ademe2024', 'ieaRecycling2024'],
  },
  impacts: {
    environmental: {
      summary: {
        text: t.envSummaryText,
        sourceRefs: ['ademe2024', 'pblEnvironmental2024'],
      },
      blocks: [
        {
          title: SECTIONS.environmentalWater,
          text: t.envWaterText,
          sourceRefs: ['usgsMcs2025', 'pblSocial2025', 'hrwGuinea2018'],
        },
        {
          title: SECTIONS.environmentalSoil,
          text: t.envSoilText,
          sourceRefs: ['pblEnvironmental2024', 'jrcBauxite2022'],
        },
        {
          title: SECTIONS.environmentalBiodiversity,
          text: t.envBiodiversityText,
          sourceRefs: [
            'pblEnvironmental2024',
            'jrcBauxite2022',
            'linGalliumArsenide2026',
          ],
        },
        {
          title: SECTIONS.environmentalClimate,
          text: t.envClimateText,
          sourceRefs: ['pblEnvironmental2024'],
        },
      ],
    },
    human: {
      summary: {
        text: t.humanSummaryText,
        sourceRefs: ['pblSocial2025', 'hrwGuinea2018'],
      },
      blocks: [
        {
          title: SECTIONS.humanDisplacement,
          text: t.humanDisplacementText,
          sourceRefs: ['pblSocial2025', 'hrwGuinea2018'],
        },
        {
          title: SECTIONS.humanWaterRights,
          text: t.humanWaterText,
          sourceRefs: ['pblSocial2025', 'hrwGuinea2018'],
        },
        {
          title: SECTIONS.humanHealth,
          text: t.humanHealthText,
          sourceRefs: ['pblSocial2025'],
        },
        {
          title: SECTIONS.humanGender,
          text: t.humanGenderText,
          sourceRefs: ['pblSocial2025'],
        },
        {
          title: SECTIONS.humanLegal,
          text: t.humanLegalText,
          sourceRefs: ['pblSocial2025'],
        },
      ],
    },
    geopolitical: {
      summary: {
        text: t.geoSummaryText,
        sourceRefs: ['usgsMcs2025', 'ieaGcmo2025'],
      },
      blocks: [
        {
          title: SECTIONS.geopoliticalDug,
          text: t.geoDugText,
          sourceRefs: ['usgsMcs2025'],
        },
        {
          title: SECTIONS.geopoliticalProcessed,
          text: t.geoProcessedText,
          sourceRefs: ['ieaGcmo2025'],
        },
        {
          title: SECTIONS.geopoliticalLeverage,
          text: t.geoLeverageText,
          sourceRefs: ['usgsMcs2025', 'ieaGcmo2025'],
        },
      ],
    },
  },
  supplyRisk: {
    summary: {
      text: t.supplySummaryText,
      sourceRefs: ['ademe2024', 'ieaGcmo2025', 'greenIt'],
    },
    blocks: [
      {
        title: SECTIONS.supplyRiskReserves,
        text: t.supplyReservesText,
        sourceRefs: ['usgsMcs2025', 'ieaGcmo2025', 'greenIt'],
      },
      {
        title: SECTIONS.supplyRiskDemand,
        text: t.supplyDemandText,
        sourceRefs: ['ademe2024'],
      },
    ],
  },
  recycling: {
    summary: {
      text: t.recyclingSummaryText,
      sourceRefs: ['ieaRecycling2024'],
    },
    blocks: [
      {
        title: SECTIONS.recyclingInput,
        text: t.recyclingInputText,
        sourceRefs: ['ieaRecycling2024'],
      },
      {
        title: SECTIONS.recyclingOutlook,
        text: t.recyclingOutlookText,
        sourceRefs: ['ieaRecycling2024'],
      },
    ],
  },
  mine0Region: t.mine0Region,
  mine1Region: t.mine1Region,
  mine2Region: t.mine2Region,
  mine3Region: t.mine3Region,
} as const
